module.exports = __webpack_public_path__ + "res/22-img_game_selected.8fdb308bc3092163b881d6254e7f32fb.png";